import isValidPhoneNumber from 'libphonenumber-js';
import datepicker from 'js-datepicker';

// Document ready
function ready(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

const logSuccess = (form, txt) => {
  let msg = form.querySelector('.form-success');
  msg.innerText = txt;
  msg.classList.add('active');

  form.querySelector('.form-error').classList.remove('active');
};

const logError = (form, txt) => {
  let msg = form.querySelector('.form-error');
  msg.innerText = txt;
  msg.classList.add('active');
};

const validate = (form, data) => {
  if (data.phone !== 'undefined') {
    if (data.phone === '') {
      logError(form, 'Please enter a phone number.');
      return false;
    } else if (!isValidPhoneNumber(data.phone, 'GB')) {
      logError(form, 'Please enter a valid phone number.');
      return false;
    }
  }

  let regexEmail = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
  if (data.email === '') {
    logError('Please enter an email address.');
    return false;
  } else if (!regexEmail.test(data.email)) {
    logError('Please enter a valid email address.');
    return false;
  }

  return true;
}

const saveData = async (formData, sheetId) => {
  try {
    const response = await fetch('/.netlify/functions/gsheet', {
      method: 'POST',
      body: {
        data: JSON.stringify(formData),
        sheetId: sheetId
      }
    });
  } catch (error) {
    console.error(error)
  }
};

const handleCallFormSubmission = (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);

  const data = {
    name: formData.get('your-name'),
    phone: formData.get('phone'),
    email: formData.get('email'),
    date: formData.get('date'),
    time: formData.get('time'),
  };

  if (validate(event.target, data)) {
    fetch('/', {
      method: 'POST',
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString()
    }).then(() => {
      logSuccess(event.target, 'Thank you! Your submission has been received!');
    }).catch((error) => {
      logError(event.target, 'Oops! Something went wrong while submitting the form.');
    });

    // saveData(formData);
  }
};

ready(function () {
  // Scroll to id
  let smoothScroll = function (identifier) {
    let element = document.querySelector(identifier)
    if (element) {
      let topPos = element.offsetTop
      window.scroll({
        top: topPos,
        behavior: 'smooth'
      });
    }
  };

  // Scroll to hash on load
  let hash = window.location.hash.substr(1);
  if (hash !== "") {
    smoothScroll('#' + hash);
  }

  let startDay = new Date();
  startDay.setDate(startDay.getDate() + 1);

  let endDay = new Date();
  endDay.setDate(endDay.getDate() + 14);

  let dateOptions = {
    startDay: 1,
    minDate: startDay,
    maxDate: endDay,
    dateSelected: startDay,
    showAllDates: true,
    noWeekends: true
  };

  let dateInputs = document.querySelectorAll('form input[name="date"]');
  dateInputs.forEach((input) => {
    datepicker(input, dateOptions);
  });

  let forms = document.querySelectorAll('form');
  forms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleCallFormSubmission(e);
    });
  });

  let pkgLinks = document.querySelectorAll('.packages--more');
  pkgLinks.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      item.parentElement.parentElement.classList.toggle('active');
    });
  });

  let faqLinks = document.querySelectorAll('.faq--item');
  faqLinks.forEach((item) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      item.classList.toggle('active');
    });
  });

  let modal = document.querySelector('.modal');
  let modalLinks = document.querySelectorAll('.modal-link');
  modalLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      modal.classList.add('active');
    });
  });

  let closeModal = function() {
    modal.classList.remove('active');
  }

  document.querySelector('.modal .close').addEventListener('click', closeModal);
  window.addEventListener('click', function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  let doc = document.documentElement;
  let w = window;

  let prevScroll = w.scrollY || doc.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;

  let header = document.getElementById('top');

  let checkScroll = function() {
    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    if (curScroll > 60) {
      header.classList.add('scrolling');
    } else {
      header.classList.remove('scrolling');
    }

    prevScroll = curScroll;
  };

  let toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > 60) {
      header.classList.add('hide');
      prevDirection = direction;
    }
    else if (direction === 1) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);
});
